import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { withDevice } from '@catalogo/core-connect/device';
import range from 'lodash/range';

const Placeholder = ({ count, height, heightTitle, width, device }) => (
  <>
    <TitleArea height={heightTitle} />
    <Wrapper>
      {range(count).map(item => (
        <Box key={item} count={count} height={height} width={width} device={device}>
          <Image />
        </Box>
      ))}
    </Wrapper>
  </>
);

export default withDevice(Placeholder);

Placeholder.defaultProps = {
  count: 5,
  height: '356px',
  heightTitle: '60px',
  width: '232px',
};

Placeholder.propTypes = {
  count: PropTypes.number,
  height: PropTypes.string,
  heightTitle: PropTypes.string,
};

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
  padding: 0 2px;
`;

const deviceStyle = {
  desktop: ({ count, height }) => css`
    flex: 0 0 calc(100% / ${count} - 20px);
    width: calc(100% / ${count} - 20px);
    height: ${height};
  `,

  mobile: ({ width, height }) => css`
    flex: ${width};
    min-width: ${width};
    height: ${height};
  `,
};

const Box = styled.div`
  margin: 6px 0;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 6px;
  position: relative;
  background-color: #fff;
  padding: 17px 40px;
  box-sizing: border-box;

  & + div {
    margin-left: 24px;
  }

  ${({ count, height, device, width }) => css`
    ${!!device && deviceStyle[device]({ count, height, width })}
  `}
`;

const Image = styled.div`
  position: relative;
  padding-top: 0;
  min-height: 1px;
  background-image: url('data:image/png;base64,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');
  background-repeat: no-repeat;
  background-color: #fff;
  background-size: 40px;
  background-position: center;
  height: 152px;
  width: 100%;
`;

const TitleArea = styled.div`
  ${({ height }) =>
    height &&
    css`
      height: ${height};
      width: 100%;
    `}
`;
